export interface ParsedFormattedAddress {
  streetAddress: string;
  city: string;
  state: string;
  zipcode: string;
}

/**
 * Best-effort parse of a US-style `formattedAddress` into structured fields.
 *
 * @param formattedAddress - Full address string from Google Places.
 * @returns Parsed street, city, state, and zip when recognizable.
 */
export function parseFormattedAddress(
  formattedAddress: string
): ParsedFormattedAddress {
  const parts = formattedAddress.split(',').map(part => part.trim());
  if (parts.length < 2) {
    return {
      streetAddress: formattedAddress,
      city: '',
      state: '',
      zipcode: '',
    };
  }

  const streetAddress = parts[0] ?? '';
  const city = parts.length >= 3 ? parts[parts.length - 2] : parts[1] ?? '';
  const stateZip = parts[parts.length - 1] ?? '';
  const stateZipMatch = stateZip.match(/^([A-Za-z]{2})\s+(\d{5}(?:-\d{4})?)$/);

  return {
    streetAddress,
    city,
    state: stateZipMatch?.[1] ?? stateZip,
    zipcode: stateZipMatch?.[2] ?? '',
  };
}
